import {
  SET_CURRENCY,
  SET_CURRENCIES,
  GET_EMPTY_BILLS,
  GET_CREDIT_LINE,
  CLEAR_EMPTY_BILLS,
  GET_CREDIT_LINE_BY_CIF,
  GET_TRANSACTIONS_BY_STATUS,
  GET_DISTRIBUTION_GRAPH,
  GET_EXPIRATION_DATES,
} from "../constants/constants";

const initialSessionState = {
  creditLine: [],
  facilities: [],
  transactions: {},
  distribution: {},
  calendarDates: [],
  currencies: [],
  currency: '',
  emptyBills: null,
};

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_CREDIT_LINE:
      return {
        ...state,
        creditLine: [ ...action.creditLine ],
      };
    case GET_TRANSACTIONS_BY_STATUS:
      return {
        ...state,
        transactions: { ...action.transactions },
      };
    case GET_DISTRIBUTION_GRAPH:
      return {
        ...state,
        distribution: { ...action.distribution },
      };
    case GET_EXPIRATION_DATES:
      return {
        ...state,
        calendarDates: [...action.calendar.list],
      };
    case GET_CREDIT_LINE_BY_CIF:
      return {
        ...state,
        facilities: [...action.creditLine]
      };
    case GET_EMPTY_BILLS:
      return {
        ...state,
        emptyBills: action.emptyBills,
      };
    case SET_CURRENCY: 
      return {
        ...state,
        currency: action.currency
      };
    case CLEAR_EMPTY_BILLS:
      return {
        ...state,
        emptyBills: null,
      };
    case SET_CURRENCIES:
      return {
        ...state,
        currencies: [...action.currencies]
      };
    default:
      return state;
  }
};

export const getCurrency = (state) => state.creditLineReducer.currency;
export const getCurrencies = (state) => state.creditLineReducer.currencies;
export const getEmptyBills = (state) => state.creditLineReducer.emptyBills;
export const getCreditLine = (state) => state.creditLineReducer?.creditLine;
export const getFacilities = (state) => state.creditLineReducer.facilities;
export const getTransactions = (state) => state.creditLineReducer.transactions;
export const getDistributions = (state) => state.creditLineReducer.distribution;
export const getExpirationsDates = (state) => state.creditLineReducer.calendarDates;
